module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji",
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-collapse-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_c('el-form', {
    staticClass: "findform",
    attrs: {
      "model": _vm.filters
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "店铺订单号："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请输入店铺订单号"
    },
    model: {
      value: (_vm.filters.vipCardName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "vipCardName", $$v)
      },
      expression: "filters.vipCardName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "所属店铺："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择",
      "filterable": ""
    },
    model: {
      value: (_vm.filters.ssmdId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "ssmdId", $$v)
      },
      expression: "filters.ssmdId"
    }
  }, _vm._l((_vm.ssmdOptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.id,
        "label": item.name
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "状态："
    }
  }, [_c('el-select', {
    ref: "mySelect",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.filters.vipOrderStatusId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "vipOrderStatusId", $$v)
      },
      expression: "filters.vipOrderStatusId"
    }
  }, _vm._l((_vm.statusoptions), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "value": item.Id,
        "label": item.Name
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "交易时间："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "type": "daterange",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.changeTimeJysj
    },
    model: {
      value: (_vm.filters.jysjTime),
      callback: function($$v) {
        _vm.$set(_vm.filters, "jysjTime", $$v)
      },
      expression: "filters.jysjTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "filterable": "",
      "clearable": "",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.filters.chengshi),
      callback: function($$v) {
        _vm.$set(_vm.filters, "chengshi", $$v)
      },
      expression: "filters.chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onExport
    }
  }, [_vm._v("导出")])], 1)], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('el-table', {
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "num",
      "label": "序号",
      "align": "center",
      "width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "店铺订单号",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.OrderNo,
            "label": scope.row.OrderNo
          }
        }, [_vm._v(_vm._s(scope.row.OrderNo))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "所属店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.BbName,
            "label": scope.row.BbName
          }
        }, [_vm._v(_vm._s(scope.row.BbName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户来源",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.UserName,
            "label": scope.row.UserName
          }
        }, [_vm._v(_vm._s(scope.row.UserName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "用户电话",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.UserPhone,
            "label": scope.row.UserPhone
          }
        }, [_vm._v(_vm._s(scope.row.UserPhone))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "交易时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.CTime,
            "label": scope.row.CTime
          }
        }, [_vm._v(_vm._s(scope.row.CTime))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "实付金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.Price,
            "label": scope.row.Price
          }
        }, [_vm._v("￥" + _vm._s(scope.row.Price))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "平台佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.CommissionPrice,
            "label": scope.row.CommissionPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.CommissionPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商家应得金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.BbPrice,
            "label": scope.row.BbPrice
          }
        }, [_vm._v("￥" + _vm._s(scope.row.BbPrice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "垫付金额",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v("￥" + _vm._s(scope.row.Othorpayprice))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "订单状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.StatusName,
            "label": scope.row.StatusName
          }
        }, [_vm._v(_vm._s(scope.row.StatusName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "align": "center",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeOrder(scope.row.Id, scope.row.StatusId)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v("查看 ")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.IsShowDeliver),
            expression: "scope.row.IsShowDeliver"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.confirmShipment(scope.row.Id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-truck"
        }), _vm._v(" 发货 ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "margin": "10px 0",
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "current-page": _vm.pageIndex,
      "page-size": 10,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)]), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "visible": _vm.dialog,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('ul', {
          staticClass: "drawer_title"
        }, [_c('li', [_vm._v("订单详情")]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.formDetails.StatusName))])])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('div', {
    staticClass: "drawer_div"
  }, [_c('ul', {
    staticClass: "drawer_ul"
  }, [_c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("订单号：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.OrderNo))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("创建日期：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.CTime))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("交易类别：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.BrandName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("付款店铺：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.BbName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("商品总价：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.formDetails.TotalPrice))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("导购员工：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.GuidancePhone))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("用户电话：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.UserPhone))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("款项类型：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.PaymentTypeName))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("优惠信息：")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "inline-table",
      "margin-left": "-40px"
    }
  }, _vm._l((_vm.formDetails.CouponsInfoList), function(item) {
    return _c('ul', {
      key: item
    }, [_c('li', [_vm._v(_vm._s(item))])])
  }), 0)]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("实付金额：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.formDetails.Price))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("垫付金额：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.formDetails.Othorpayprice))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("货款金额：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.BbPrice))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("返现金额：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.formDetails.ReturnPrice))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("导购佣金：")]), _vm._v(" "), _c('span', [_vm._v("￥" + _vm._s(_vm.formDetails.GuidePrice))])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("纸质凭证：")]), _vm._v(" "), _vm._l((_vm.formDetails.VipContractVoucherList), function(itemImgUrl) {
    return _c('span', {
      key: itemImgUrl.VoucherUrl
    }, [_c('el-image', {
      staticClass: "imgUrl",
      attrs: {
        "src": itemImgUrl.VoucherUrl,
        "preview-src-list": [itemImgUrl.VoucherUrl]
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  })], 2), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("交易备注：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.Remark))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDetails.StatusId != 6),
      expression: "formDetails.StatusId != 6"
    }]
  }, [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("退款说明：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.formDetails.RefundRemark))])]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDetails.StatusId == 9),
      expression: "formDetails.StatusId == 9"
    }]
  }, [_c('span', {
    staticClass: "watch_first"
  }, [_vm._v("退款失败说明：")]), _vm._v(" "), _c('span', [_vm._v("请使用资金管理员微信扫码登录https://pay.weixin.qq.com/（或登录微信“商家助手”小程序）查看账户可用余额大于等于本订单货款金额，如金额不足请先进行充值后再次发起退款申请；如账户可用金额大于等于本订单货款依然是退款失败或有其它疑问请联系400-157-7588。")])])]), _vm._v(" "), _c('div', {
    staticClass: "drawer_foot"
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDetails.StatusId == 6),
      expression: "formDetails.StatusId == 6"
    }],
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        return _vm.tuikuan(1)
      }
    }
  }, [_vm._v("同意退款")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDetails.StatusId == 6),
      expression: "formDetails.StatusId == 6"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.tuikuan(0)
      }
    }
  }, [_vm._v("拒绝退款")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formDetails.StatusId == 9),
      expression: "formDetails.StatusId == 9"
    }],
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.cxfqtk(1)
      }
    }
  }, [_vm._v("重新发起退款")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.cancelForm
    }
  }, [_vm._v("关 闭")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "发货提示",
      "visible": _vm.seeFhtx,
      "center": true,
      "width": "30%",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.seeFhtx = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("确定该订单商品已经被用户取走或已配送安装了吗？")]), _vm._v(" "), _c('P', [_vm._v("温馨提示：确定发货后，订单将在14天内自动确认收货；")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.fixFh
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.seeFhtx = false
      }
    }
  }, [_vm._v("取消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "退款审核",
      "visible": _vm.seeTksh,
      "center": true,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.seeTksh = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "label": "审核备注："
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入审核备注",
      "maxlength": "100"
    },
    model: {
      value: (_vm.shenmark),
      callback: function($$v) {
        _vm.shenmark = $$v
      },
      expression: "shenmark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.qdTksh()
      }
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.seeTksh = false
      }
    }
  }, [_vm._v("取 消")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "退款提示",
      "visible": _vm.seeTktx,
      "center": true,
      "width": "25%",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.seeTktx = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-bottom": "20px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("确定重新发起退款吗？")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.fixTk
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.seeTktx = false
      }
    }
  }, [_vm._v("取消")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "model_section"
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v("店铺交易记录")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-121221c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/financialManagement/transactionsPlatform.vue
// module id = 1635
// module chunks = 3